/* NOCTEVRA theme script — vanilla JS, no dependencies (~12 KB unminified). */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = window.NOCTEVRA || { routes: {} };

  function safeSession(key, val) {
    try {
      if (val === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ------------------------------------------------------------ intro */
  function initIntro() {
    var intro = $('[data-intro]');
    if (!intro) return;
    if (intro.hidden) { intro.remove(); return; } // inline script already decided to skip
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      safeSession('noctevra-intro', '1');
      intro.classList.add('is-done');
      document.documentElement.style.overflow = '';
      setTimeout(function () { intro.remove(); }, 800);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') finish(); }
    $('[data-intro-skip]', intro).addEventListener('click', finish);
    intro.addEventListener('click', finish);
    document.addEventListener('keydown', onKey);
    setTimeout(finish, 2900);
  }

  /* ------------------------------------------------------------ header */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var lastY = window.scrollY;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      header.classList.toggle('is-hidden', y > 400 && y > lastY + 4);
      if (y < lastY - 4) header.classList.remove('is-hidden');
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();

    var nav = $('[data-mobile-nav]');
    $$('[data-nav-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = nav.hidden;
        nav.hidden = !open;
        document.documentElement.style.overflow = open ? 'hidden' : '';
        $$('[data-nav-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
        if (open) { var c = $('.mobile-nav__close', nav); if (c) c.focus(); }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav && !nav.hidden) $('[data-nav-toggle]').click();
    });
  }

  /* ------------------------------------------------------------ reveal + draw */
  function initReveal(root) {
    var els = $$('.reveal, .reveal-image, .draw-on-scroll', root);
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------ parallax */
  function initParallax() {
    if (reduceMotion) return;
    var items = $$('[data-parallax]');
    if (!items.length) return;
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? visible.add(e.target) : visible.delete(e.target); });
    });
    items.forEach(function (el) { io.observe(el); });
    var ticking = false;
    function frame() {
      visible.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
        var r = el.getBoundingClientRect();
        var offset = (r.top + r.height / 2 - window.innerHeight / 2) * speed * -1;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(frame); ticking = true; }
    }, { passive: true });
    frame();
  }

  /* ------------------------------------------------------------ starfield */
  function initStars() {
    var canvas = $('[data-starfield]');
    if (!canvas || reduceMotion) { if (canvas) canvas.remove(); return; }
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var stars = [];
    var running = true;
    function resize() {
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      var count = Math.round((window.innerWidth * window.innerHeight) / 9000);
      stars = [];
      for (var i = 0; i < Math.min(count, 180); i++) {
        stars.push({ x: Math.random() * canvas.width, y: Math.random() * canvas.height, r: (Math.random() * 0.9 + 0.2) * dpr, p: Math.random() * Math.PI * 2, s: 0.004 + Math.random() * 0.012 });
      }
    }
    var last = 0;
    function draw(t) {
      if (!running) return;
      requestAnimationFrame(draw);
      if (t - last < 66) return; // ~15fps is plenty for twinkling and easy on batteries
      last = t;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        s.p += s.s * 4;
        ctx.globalAlpha = 0.25 + Math.abs(Math.sin(s.p)) * 0.55;
        ctx.fillStyle = '#e8e2d4';
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 6.283); ctx.fill();
      }
    }
    resize();
    window.addEventListener('resize', resize);
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) requestAnimationFrame(draw);
    });
    requestAnimationFrame(draw);
  }

  /* ------------------------------------------------------------ cart */
  var drawer = null;
  function openDrawer() {
    drawer = $('[data-cart-drawer]');
    if (!drawer) { window.location.href = cfg.routes.cart; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = $('.drawer__panel', drawer);
    if (panel) panel.focus();
  }
  function closeDrawer() {
    drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function sectionsToRender() {
    var ids = [];
    if ($('[data-cart-drawer]')) ids.push('cart-drawer');
    return ids;
  }
  function renderCartSections(sections, count) {
    if (sections && sections['cart-drawer']) {
      var tmp = document.createElement('div');
      tmp.innerHTML = sections['cart-drawer'];
      var fresh = $('[data-cart-contents]', tmp);
      var head = $('#CartDrawerTitle', tmp);
      var cur = $('[data-cart-drawer] [data-cart-contents]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      if (head && $('#CartDrawerTitle')) $('#CartDrawerTitle').textContent = head.textContent;
    }
    if (typeof count === 'number') {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      });
    }
  }
  function refreshCartPage() {
    var page = $('[data-cart-page]');
    if (!page) return Promise.resolve();
    return fetch(cfg.routes.cart + '?section_id=main-cart')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = $('[data-cart-page]', tmp);
        if (fresh) page.innerHTML = fresh.innerHTML;
      });
  }
  function changeLine(line, qty) {
    var wrap = $$('[data-cart-contents]');
    wrap.forEach(function (w) { w.classList.add('is-updating'); });
    return fetch(cfg.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: sectionsToRender() })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartSections(cart.sections, cart.item_count);
        return refreshCartPage();
      })
      .catch(function () { toast('Something went wrong. Please refresh the page.'); })
      .finally(function () { wrap.forEach(function (w) { w.classList.remove('is-updating'); }); });
  }
  function initCart() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && cfg.cartType === 'drawer' && $('[data-cart-drawer]')) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      var changer = e.target.closest('[data-line-change]');
      if (changer) {
        e.preventDefault();
        changeLine(parseInt(changer.getAttribute('data-line-change'), 10), parseInt(changer.getAttribute('data-qty'), 10));
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ------------------------------------------------------------ product */
  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas.split('.')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function initProduct(root) {
    var variantsEl = $('[data-variants]', root);
    var form = $('[data-product-form]', root);
    if (!form) return;
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var addLabel = $('[data-add-label]', form);
    var errorEl = $('[data-form-error]', form);
    var priceWrap = $('[data-price-wrap]', root);

    function selectedOptions() {
      return $$('.option', root).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function markAvailability(current) {
      $$('.option', root).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var opts = current.slice(); opts[idx] = input.value;
          var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }
    function onChange() {
      var opts = selectedOptions();
      $$('.option', root).forEach(function (fs, i) { var v = $('[data-option-value]', fs); if (v) v.textContent = opts[i]; });
      var variant = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      markAvailability(opts);
      if (!variant) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (priceWrap) {
        var p = $('[data-price]', priceWrap);
        if (p) p.textContent = formatMoney(variant.price);
        var cp = $('[data-compare-price]', priceWrap);
        if (cp) cp.hidden = !(variant.compare_at_price > variant.price);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media) {
        var slide = $('[data-media-id="' + variant.featured_media.id + '"]', root);
        var track = $('[data-gallery-track]', root);
        if (slide && track && track.scrollWidth > track.clientWidth) track.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    $$('[data-option-input]', root).forEach(function (i) { i.addEventListener('change', onChange); });
    if (variants.length > 1) markAvailability(selectedOptions());

    // quantity
    $$('[data-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $('.qty__input', root);
        var v = Math.max(1, Math.min(20, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10)));
        input.value = v;
      });
    });

    // add to cart
    form.addEventListener('submit', function (e) {
      if (cfg.cartType !== 'drawer' || !$('[data-cart-drawer]')) return; // normal form post → cart page
      e.preventDefault();
      errorEl.hidden = true;
      addBtn.classList.add('is-loading');
      var fd = new FormData(form);
      fd.append('sections', sectionsToRender().join(','));
      fetch(cfg.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.json.description || res.json.message || 'Could not add to cart.'); }
          return fetch(cfg.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            renderCartSections(res.json.sections, cart.item_count);
            openDrawer();
          });
        })
        .catch(function (err) { errorEl.textContent = err.message; errorEl.hidden = false; })
        .finally(function () { addBtn.classList.remove('is-loading'); });
    });

    // gallery dots / counter
    var track = $('[data-gallery-track]', root);
    var dots = $$('.gallery__dot', root);
    var counter = $('[data-gallery-index]', root);
    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        if (counter) counter.textContent = i + 1;
      }, { passive: true });
    }

    // lightbox
    var lb = $('[data-lightbox-dialog]', root);
    $$('[data-lightbox]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!lb || typeof lb.showModal !== 'function') return;
        $('[data-lightbox-img]', lb).src = btn.getAttribute('data-lightbox');
        lb.showModal();
      });
    });
  }

  /* ------------------------------------------------------------ dialogs */
  function initDialogs() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-dialog-open]');
      if (opener) {
        var d = document.getElementById(opener.getAttribute('data-dialog-open'));
        if (d && typeof d.showModal === 'function') d.showModal();
        return;
      }
      if (e.target.closest('[data-dialog-close]')) {
        var dlg = e.target.closest('dialog'); if (dlg) dlg.close(); return;
      }
      if (e.target.tagName === 'DIALOG') e.target.close(); // click on backdrop
    });
  }

  /* ------------------------------------------------------------ symbols */
  function initSymbols(root) {
    var section = $('[data-symbols]', root);
    if (!section) return;
    var tabs = $$('[data-symbol-tab]', section);
    var cache = {};
    function load(panel) {
      var results = $('[data-symbol-results]', panel);
      var url = panel.getAttribute('data-results-url');
      if (!results || results.dataset.loaded) return;
      results.classList.add('is-loading');
      var req = cache[url] || (cache[url] = fetch(url + '?section_id=symbol-products').then(function (r) { if (!r.ok) throw 0; return r.text(); }));
      req.then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('.shopify-section') || tmp;
        results.innerHTML = inner.innerHTML;
        results.dataset.loaded = '1';
        initReveal(results);
      }).catch(function () {
        results.innerHTML = '';
      }).finally(function () { results.classList.remove('is-loading'); });
    }
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) { panel.hidden = !on; if (on) { load(panel); initReveal(panel); } }
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
    // lazy-load first panel's products when the section scrolls into view
    var first = $('[data-symbol-panel]:not([hidden])', section);
    if (first && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { load(first); io.disconnect(); }
      }, { rootMargin: '300px' });
      io.observe(section);
    } else if (first) { load(first); }
  }

  /* ------------------------------------------------------------ recommendations */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (el.children.length) return;
      var go = function () {
        fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var fresh = $('[data-recommendations]', tmp);
          if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveal(el); }
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { go(); io.disconnect(); } }, { rootMargin: '400px' });
        io.observe(el);
      } else { go(); }
    });
  }

  /* ------------------------------------------------------------ misc */
  function initAutosubmit() {
    $$('[data-autosubmit]').forEach(function (s) {
      s.addEventListener('change', function () { s.form.submit(); });
    });
  }

  function initPageTransitions() {
    if (reduceMotion || !document.body.classList.contains('anim')) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank' || a.hasAttribute('download')) return;
      if (a.origin !== location.origin || a.hash && a.pathname === location.pathname) return;
      if (/\/(checkout|cart\/|account\/logout)/.test(a.pathname) || a.closest('[data-cart-drawer]')) return;
      e.preventDefault();
      document.body.classList.add('is-leaving');
      setTimeout(function () { location.href = a.href; }, 220);
    });
    window.addEventListener('pageshow', function () { document.body.classList.remove('is-leaving'); });
  }

  function initAll(root) {
    initReveal(root);
    $$('[data-product-root]', root).forEach(initProduct);
    initSymbols(root);
    initRecommendations(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initIntro();
    initHeader();
    initCart();
    initDialogs();
    initParallax();
    initStars();
    initAutosubmit();
    initPageTransitions();
    initAll(document);
  });

  // Theme editor: re-initialise sections when merchants edit them
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
